var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpening(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 1707 1707",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1193 1567H167c-65 0-117-52-117-116V829c0-65 52-117 117-117h1243c65 0 117 52 117 117v417c-27-11-56-17-86-18V831c0-18-15-33-33-33H169c-18 0-33 15-33 33v618c0 18 15 32 33 32h1010v3c0 29 5 57 14 83zm208-337c-111 15-200 101-218 211H176V838h1225zm-990 14c-77 0-140-63-140-141 0-77 63-140 140-140 78 0 141 63 141 140 0 78-63 141-141 141zm0-241c-55 0-100 45-100 100 0 56 45 101 100 101 56 0 101-45 101-101 0-55-45-100-101-100zm301 130h-53v91c0 11-9 20-20 20s-20-9-20-20V981c0-8 5-14 11-16 2-2 6-3 9-3h73c112 0 112 171 0 171zm-53-40c36 0 98 9 98-46 0-54-62-45-98-45zm348 30h-97v78c0 5 87 3 97 3 26 0 26 40 0 40h-95c-23 0-42-19-42-43v-196c0-24 19-43 42-43h95c26 0 26 40 0 40-10 0-97-2-97 2v79h97c26 0 26 40 0 40zm279 121h-3v-1h-4v-1h-2v-1h-2c-2-2-4-4-5-6l-137-191v180c0 11-9 20-20 20s-20-9-20-20V985c0-3 0-6 1-8 2-8 7-12 14-14 6-2 12-1 17 3 3 2 5 4 6 7l135 189V982c0-26 40-26 40 0v242c0 9-6 17-15 19h-2v1h-2z",
    fill: "#FFA217",
    opacity: 1,
    "data-original": "#FFA217",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358 768c-10 0-19-3-26-10L863 289c-34-34 18-86 52-52l469 469c23 23 6 62-26 62zm-1139 0c-32 0-48-39-25-62l468-469c34-34 86 18 52 52L245 758c-7 7-16 10-26 10z",
    fill: "#FFA217",
    opacity: 1,
    "data-original": "#FFA217",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789 325c-90 0-162-73-162-162C627 73 699 1 789 1c89 0 161 72 161 162 0 89-72 162-161 162zM1435 1355c-28 0-20-39-20-74 0-26 40-26 40 0 0 35 7 74-20 74z",
    fill: "#FFA217",
    opacity: 1,
    "data-original": "#FFA217",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 1706c-123 0-223-100-223-222 0-123 100-223 223-223 122 0 222 100 222 223 0 122-100 222-222 222zm0-405c-101 0-183 82-183 183 0 100 82 182 183 182 100 0 182-82 182-182 0-101-82-183-182-183z",
    fill: "#FFA217",
    opacity: 1,
    "data-original": "#FFA217",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637 1504c-35 0-74 7-74-20 0-28 39-20 74-20 26 0 26 40 0 40zM1435 1706c-28 0-20-39-20-74 0-26 40-26 40 0 0 35 7 74-20 74zM1286 1504c-35 0-74 7-74-20 0-28 39-20 74-20 27 0 27 40 0 40zM1520 1504c-126 0-107 18-107-108 0-26 40-26 40 0v68h67c26 0 26 40 0 40z",
    fill: "#FFA217",
    opacity: 1,
    "data-original": "#FFA217",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpening);
export default __webpack_public_path__ + "static/media/opening.d3e62735cc8081ee1f4595921d0e9b40.svg";
export { ForwardRef as ReactComponent };